import AppVersionInfoService from "./AppVersionInfoService";
import AppVersionInfoApiRouteService from "./AppVersionInfoApiRouteService";

class HandheldAppVersionInfoService extends AppVersionInfoService {
    constructor(apiClient) {
        super(apiClient, new AppVersionInfoApiRouteService("handheld-app-version"));
    }
}

export default HandheldAppVersionInfoService;
